<template>
  <div>
    <add-payment-provider :is-active.sync="isAdding" @changed="paymentProviderAdded" />
    <data-table
      title="Crypto Providers"
      :url="url"
      :headers="headers"
      :fields="fields"
      ref="table"
      searchable
      @click:row="showDetails"
      @rowClicked="showDetails"
    >
      <template slot="action.icons">
        <v-btn color="primary" @click="isAdding = true">
          <v-icon color="light-blue lighten-4">
            mdi-plus-outline
          </v-icon>
          Add Payment Provider
        </v-btn>
      </template>
    </data-table>
  </div>
</template>

<script>
import AddPaymentProvider from "./form";

export default {
  components: { AddPaymentProvider },
  data() {
    return {
      isAdding: false,
      url: "/api/v1/transactions/cryptoPaymentProviders",
      headers: {
        name: "Name",
      },
      fields: {
        min_amount: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
        max_amount: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
      },
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    paymentProviderAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    showDetails({ id }) {
      this.$router.push({ name: "crypto.paymentProviders.show", params: { id } });
    },
  },
};
</script>
